import { getComponents } from '@/theme/themes/components';
import { loadBrandFont } from '@/theme/themes/font';
import { getTypography } from '@/theme/themes/typography';
import { createTheme } from '@mui/material';
import { createPalette } from '@/theme/themes/colors';

export function createMuiTheme(primaryColor?: string) {
  const palette = createPalette(primaryColor);
  const brandFontFaces = loadBrandFont();
  const components = getComponents(brandFontFaces);
  const typography = getTypography();

  return createTheme({
    typography,
    palette,
    components
  });
}
